<template lang="pug">
  .div
    .thrid-btn(@click="show_third_search_box=true" v-if="hasJoinTmall")
      span.btn 第三方订单核销  
      el-popover.tips-text(placement="top-start", width="200", trigger="hover", :content="'支持对天猫商城、京东商城、 壳牌抖音小程序商城和壳牌微信小程序商城的订单信息进行核销。'")
        .el-icon-question(slot="reference")
    .workbenck-operation-pannel
      .label.service 请输入核销码
      .auto-complete-input
        .select 核销码
        input.input(v-model="queryStr", @keyup.enter="searchAll", ref="input2")
      button.button.large.primary(@click="searchAll") 查询
      card-off-modal(v-if="modalShow && modal_show_type == 2", :cardInfo="cardInfo", :checkCode="queryStr", @input="toggleWriteOffModal", @success="handleModal")
      write-off-modal(v-if="modalShow && modal_show_type == 1", :service-item="serviceItem", :user-info="userInfo", :purchase_type="purchase_type", :trade-order="tradeOrder", :nonWriteOffItem="non_write_off_item", @input="toggleWriteOffModal", @success="handleModal")
      card-management-modal(v-if="modalShow && modal_show_type == 3 && !is_self",  @input="toggleWriteOffModal",:info="group_info", @success="handleModal")
      card-self-modal(v-if="modalShow && modal_show_type == 3 && is_self", @input="toggleWriteOffModal",:info="group_info", @success="handleModal")
      plat-coupon-modal(v-if="modalShow && modal_show_type == 4", :cardInfo="cardInfo", :checkCode="queryStr", @input="toggleWriteOffModal", @success="handleModal")     
      third-search-modal(v-if="show_third_search_box" v-model="show_third_search_box" @confirm="thirdSearchInput")
      tmall-write-modal(v-if="show_tmall_write_box" v-model="show_tmall_write_box" :info="third_order_info" @success="handleModal")
      jd-write-modal(v-if="show_jd_write_box" v-model="show_jd_write_box" :info="third_order_info" @success="handleModal")
      o2o-write-modal(v-if="show_o2o_write_box" v-model="show_o2o_write_box" :info="third_order_info" @success="handleModal")
</template>

<script>
import CardSelfModal from '@/components/workbench/model/CardSelfModal'
import CardManagementModal from '@/components/workbench/model/CardManagementModal'
import WriteOffModalGroup from '@/components/workbench/model/WriteOffModalGroup'
import WriteOffModal from '@/components/workbench/model/WriteOffModal'
import CardOffModal from '@/components/workbench/model/CardOffModal'
import PlatCouponModal from '@/components/workbench/model/PlatCouponModal'
import ThirdSearchModal from '@/components/workbench/model/ThirdSearchModal'
import TmallWriteModal from '@/components/workbench/model/TmallWriteModal'
import JdWriteModal from '@/components/workbench/model/JdWriteModal'
import O2oWriteModal from '@/components/workbench/model/O2oWriteModal'
import workbenchMixin from '@/mixins/modules/workbench'

export default {
  name: 'ReservationWriteOff',
  mixins: [workbenchMixin],
  components: {
    WriteOffModalGroup,
    WriteOffModal,
    CardOffModal,
    CardManagementModal,
    CardSelfModal,
    PlatCouponModal,
    ThirdSearchModal,
    TmallWriteModal,
    JdWriteModal,
    O2oWriteModal,
  },
  props: {
    string: '',
  },
  data () {
    return {
      queryStr: '',
      // modal
      modalShow: false,
      modal_show_type: null,
      userInfo: null,
      serviceItem: null,
      group_info: null,
      tradeOrder: null,
      cardInfo: null,
      is_self: false,
      show_third_search_box: false,
      show_tmall_write_box: false,
      show_jd_write_box: false,
      show_o2o_write_box: false, // 抖音和商城核销弹层
      hasJoinTmall: false,
      third_order_info: {},
      purchase_type: 0,   // 订单来源：1 门店，2 平台， 3 第三方
      non_write_off_item: null, // 订单核销项目信息数据
    }
  },
  watch: {
    'queryStr' () {
      this.queryStr = this.queryStr.replace(/[\W]/g, '')
    },
  },
  mounted () {
    this.getJoinStatus()
  },
  methods: {
    async getJoinStatus () {
      try {
        const { response, result } = await this.JoinStatusApi({
          third_store_type: 1,
        })
        if (response.status === 200 && result.code === 0) {
          this.hasJoinTmall = result.data.has_join === 1
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取加入平台状态失败',
            content: result.message,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取加入平台状态失败',
          content: `出错啦！错误码： ${err}`,
        })
      }
    },
    // 核销码确认
    async thirdSearchInput (e) {
      console.log(e)
      let writeCode = e.write_code
      try {
        // 天猫
        if (writeCode.length === 10) {
          const { response, result } = await this.TMallOrderDetailApi({
            write_code: writeCode,
          })
          if (response.status === 200 && result.code === 0) {
            result.data.items = result.data.items.map(i => {
              i.number = 0
              return i
            })
            this.third_order_info = result.data
            this.third_order_info.write_code = e.write_code
            this.show_tmall_write_box = true
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '核销失败',
              content: result.message,
            })
          }
        }
        // 京东
        if (writeCode.length === 11) {
          let { response, result } = await this.JDOrderCheck({
            write_code: writeCode,
          })
          if (response.status === 200 && result.code === 0) {
            this.getJdDetail(writeCode)
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '核销失败',
              content: result.message,
            })
          }
        }
        // 9抖音 8壳牌喜力官方商城
        if (writeCode.length === 8 || writeCode.length === 9) {
          let type = writeCode.length === 8 ? 4 : 3
          let { response, result } = await this.o2oWriteOffInfo({
            write_code: writeCode,
            write_type: type,
          })
          if (response.status === 200 && result.code === 0) {
            result.data.order_item = result.data.order_item.map(i => {
              i.number = 0
              return i
            })
            this.third_order_info = result.data
            this.third_order_info.write_code = writeCode
            this.show_o2o_write_box = true
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '核销失败',
              content: result.message,
            })
          }
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取订单详情失败',
          content: `出错啦！错误码： ${err}`,
        })
      }
    },
    async getJdDetail (writeCode) {
      let { response, result } = await this.JDOrderDetailApi({
        write_code: writeCode,
      })
      if (response.status === 200 && result.code === 0) {
        result.data.order_item = result.data.order_item.map(i => {
          i.number = 0
          return i
        })
        this.third_order_info = result.data
        this.third_order_info.write_code = writeCode
        this.show_jd_write_box = true
      } else {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '核销失败',
          content: result.message,
        })
      }
    },
    // 抖音 官方商城详情
    async getO2oDetail (writeCode, type) {
      let { response, result } = await this.o2oWriteOffInfo({
        write_code: writeCode,
        write_type: type,
      })
      if (response.status === 200 && result.code === 0) {
        result.data.order_item = result.data.order_item.map(i => {
          i.number = 0
          return i
        })
        this.third_order_info = result.data
        this.third_order_info.write_code = writeCode
        this.show_jd_write_box = true
      } else {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '核销失败',
          content: result.message,
        })
      }
    },
    // 平台券核销详情
    async search3 () {
      // this.modalShow = true
      if (!this.queryStr) {
        return
      }
      try {
        const { response, result } = await this.searchPlatCoupon({ checkCode: this.queryStr })
        if (response.status === 200) {
          if (result.code && result.code !== 0) {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '查询失败',
              content: `${result.message}`,
            })
            this.modalShow = false
            return false
          } else {
            this.cardInfo = result.data
            this.modalShow = true
          }
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '查询失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '查询失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
    },
    // 优惠券核销详情(优惠券核销搜索)
    async search1 () {
      // this.modalShow = true
      if (!this.queryStr) {
        return
      }
      try {
        const { response, result } = await this.searchCord(this.queryStr)
        if (response.status === 200) {
          if (result.code && result.code !== 0) {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '查询失败',
              content: `${result.message}`,
            })
            this.modalShow = false
            return false
          } else {
            this.cardInfo = result.data
            this.modalShow = true
          }
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '查询失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '查询失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
    },
    // 查询核销订单详情
    async search () {
      if (!this.queryStr) {
        return
      }
      try {
        const { response, result } = await this.checkDetail({
          write_code: this.queryStr,
        })
        if (response.status === 200 && result.code === 0) {
          this.non_write_off_item = result.data.non_write_off_item.map(item => {
            item.number = 0
            return item
          })
          // 如果没有待核销项目
          if (!this.non_write_off_item.length) {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '提示',
              content: '该订单全部项目已核销完成',
            })
            return
          }
          this.userInfo = result.data.customer
          this.userInfo.customer_id = result.data.customer_id
          this.purchase_type = parseInt(result.data.purchase_type)
          this.tradeOrder = {
            tradeOrderNo: result.data.order_no,
            tradeOrderId: result.data.order_id,
            writeOffCode: result.data.order_extend.write_code,
          }
          this.serviceItem = result.data.item
          this.modalShow = true
        } else if (result.code === 77777777) {
          // 订单核销(不在有效期内)
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '订单失效',
            content: result.message,
          })
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '查询失败',
            content: result.message,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '查询失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
    },
    // 卡核销详情(卡核销搜索)
    async search2 () {
      if (this.queryStr.length === 0) {
        return
      }
      let str = this.queryStr.toUpperCase()
      if (str.indexOf('VIP') === -1) str = 'VIP' + str
      try {
        const { response, result } = await this.getCardManagementInfoApi({
          upkeep_no: str,
        })
        if (response.status === 200) {
          if (result.code !== 0) {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '查询失败',
              content: `${result.message}`,
            })
            this.modalShow = false
            return false
          } else {
            result.data.upkeep_no_new = result.data.upkeep_no.substring(0, result.data.upkeep_no.length - 8) + '****' + result.data.upkeep_no.substring(result.data.upkeep_no.length - 4, result.data.upkeep_no.length)
            result.data.item.forEach(ele => {
              if (result.data.type === 1) {
                ele.is_select = false
                ele.number = 0
              } else {
                ele.number = 0
              }
            })
            result.data.item_use.forEach(ele => {
              ele.number = 0
            })
            let arr = result.data.item_use
            result.data.item_use = arr.sort((n, m) => {
              return m.is_end - n.is_end
            })
            if (result.data.type === 1 || result.data.type === 3) {
              this.is_self = false
              result.data.project = result.data.item
              result.data.item = result.data.item_use
              result.data.has_num = result.data.surplus
              result.data.need_num = result.data.count_num - result.data.num
            } else {
              this.is_self = true
            }
            result.data.expiry_time = this.changeDateTime(result.data.expiry_time)
            this.group_info = result.data
            this.modalShow = true
          }
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '查询失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch (err) {
        console.log(err)
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '查询失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
    },
    searchAll () {
      let _this = this
      this.queryStr = this.queryStr.toLocaleUpperCase().indexOf('VIP') !== -1 ? this.queryStr.substr(3) : this.queryStr
      console.log(this.queryStr.substring(0, 2))
      switch (this.queryStr.substring(0, 2)) {
        case '01':
          _this.modal_show_type = 1
          _this.search()
          break
        case '02':
          _this.modal_show_type = 2
          _this.search1()
          break
        case '03':
          _this.modal_show_type = 3
          _this.search2()
          break
        case '04':
          _this.modal_show_type = 4
          _this.search3()
          break
        default:
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '查询失败',
            content: '暂无可核销信息',
          })
      }
      _this.queryStr = ''
    },
    // 弹层开关
    toggleWriteOffModal () {
      this.modalShow = !this.modalShow
      if (!this.modalShow) {
        this.$el.querySelector('.input').select()
      }
    },
    // 确认核销回调
    handleModal () {
      this.$emit('success', {
        type: this.modal_show_type,
      })
      this.queryStr = ''
    },
    /**
     * 时间戳转年月日
     * @val  时间戳
     */
    changeDateTime (val, type) {
      if (!val) {
        return ''
      }
      let date = new Date(val * 1000)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = this.judgeTime(date.getDate()) + ' '
      let h = this.judgeTime(date.getHours()) + ':'
      let m = this.judgeTime(date.getMinutes())
      if (type === 'data') {
        return Y + M + D
      } else if (type === 'datetime') {
        return Y + M + D + h + m
      } else {
        return Y + M + D + h + m
      }
    },
    /**
     * 时 分 格式化
     * @t  时分
     */
    judgeTime (t) {
      if (t < 10) {
        return '0' + t
      } else {
        return t
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.div
  width 100%
  display flex
  justify-content center
  position relative
  .thrid-btn:hover
    box-shadow 0 2px 4px 0 rgba(0, 0, 0, 0.08)
    top 17px !important
  .thrid-btn
    position absolute
    right 50px
    top 18px
    cursor pointer
    display flex
    align-items center
    justify-content center
    line-height 40px
    border-radius 3px
    padding 0 10px
    background #ffbb29
    color #121212
    .btn
      margin-right 5px
      font-size 12px
.workbenck-operation-pannel
  max-width 574px
  position relative
  flex 1 1 auto
  display flex
  justify-content space-between
  margin-right 16px
  padding 16px 16px
  padding-left 188px
  background-color #fff
  border-radius 3px
  flex-grow 0
  &:last-child
    margin-right 0
  .label
    position absolute
    top 16px
    left 0
    display block
    padding-left 64px
    height 40px
    font-size 18px
    line-height 40px
    color standblack
    // border-left 1px solid rgba(0, 0, 0, .08)
    &::after
      content ''
      position absolute
      top 8px
      left 32px
      width 24px
      height 24px
      background center no-repeat
    &.service::after
      background-image url('~@/assets/workbench-service-black.svg')
  .button
    margin-left 8px
    width 96px
    flex 0 0 96px
.auto-complete-input
  position relative
  display inline-block
  flex 1 1 auto
  .select
    position absolute
    left 0
    top 0
    height 40px
    padding 8px 16px
    font-size 16px
    line-height 24px
    color darker
    &::after
      content ''
      position absolute
      top 8px
      right 0
      height 24px
      border-left 1px solid line
  .input
    padding 8px 12px
    padding-left 96px
    font-size 16px
    line-height 22px
.auto-complete-list
  position absolute
  top 37px
  width 100%
  max-height 280px
  overflow-y auto
  padding 8px 0
  background-color #fff
  border 1px solid #c2c2c2
  box-shadow 0 4px 12px 0 rgba(0, 0, 0, 0.1)
  z-index 2
.auto-complete-item
  height 32px
  padding 0 16px
  font-size 13px
  line-height 32px
  color darker
  cursor pointer
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  .number, .name
    display inline-block
  .name
    padding-left 30px
    color placeholder
  &:hover
    background-color hover
.tips-text
  color #e7e7e7
</style>



// WEBPACK FOOTER //
// src/components/workbench/WriteOffAll.vue